import React from "react";
import { Box, Flex, Button, Text } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { ModalBox } from "../../components/ModalBox";
import { FormInput } from "../../components/FormInput";
import { PaginatedDataTable } from "../../components/PaginatedDataTable";
import { StaticUploadImage } from "../../components/StaticUploadImage";
import { FormTextArea } from "../../components/FormTextArea";
import { useInstructors } from "../../hooks/useInstructors"
import { LoadingOverlay } from "../../components/LoadingOverlay";
import { CreateInstructor } from "../../components/CreateInstructor.js";
import { HelmetComponent } from "../../components/HelmetComponent";

export const InstructorsPage = () => {
  const {
    instructor,
    instructors,
    instructorsColumn,
    openAddInstructor,
    addInstructorIsOpen,
    onModalClose,
    addInstructors,
    onChange,
    updateModalIsOpen,
    updateModalClose,
    updateInstructorCallback,
    deleteModalIsOpen,
    deleteModalOnClose,
    deleteResource,
    setInstructor,
    loading,
    list,
    staffs,
    user,
    publisher
  } = useInstructors();

  return (
    <>
      <HelmetComponent title={`Instructors - Home - ${user.firstName} ${user.lastName}`}/>
      {loading && <LoadingOverlay />}
      <Box id="no-more-tables">
        <Box>
          <Flex
            sx={{
              marginTop: "20px",
              justifyContent: "flex-end",
            }}
          >
            <Button onClick={openAddInstructor} colorScheme="blue" disabled={!publisher.isPro}>
              <AddIcon marginRight={"5px"} /> Add Instructor
            </Button>
          </Flex>
        </Box>
        {
          instructors?.length === 0 ?
            <Text>No Instructor added.</Text> :
            <PaginatedDataTable
              columns={instructorsColumn}
              data={instructors}
              showNumberOfRecords={50}
            />
        }
        <ModalBox
          title="Add Instuctor"
          isOpen={addInstructorIsOpen}
          onClose={onModalClose}
          isFooter={true}
          onCancel={onModalClose}
          confirmButtonType={true}
          onConfirm={addInstructors}
          confirmButtonText="Create"
          size="2xl"
          description={
            <CreateInstructor
              instructor={instructor}
              staffs={staffs}
              onChange={onChange}
              list={list}
            />
          }
        ></ModalBox>
        <ModalBox
          title="Update Instructor"
          isOpen={updateModalIsOpen}
          onClose={updateModalClose}
          isFooter={true}
          onCancel={updateModalClose}
          confirmButtonType={true}
          onConfirm={updateInstructorCallback}
          confirmButtonText="Update"
          description={
            <>
              <FormInput
                formProps={{
                  isRequired: true,
                  maxWidth: "200px",
                }}
                padding="20px 0 0 0"
                label="Instructor Name"
                value={instructor?.InstructorName}
                name="InstructorName"
                isDisabled={true}
              />
              <FormTextArea
                name="InstructorBio"
                inputName="InstructorBio"
                value={instructor?.InstructorBio}
                inputOnChange={(e) => onChange(e, instructor?.id)}
                padding="20px 0 20px 0"
                isRequired={true}
                maxWidth="600px"
              />
              <StaticUploadImage
                label="Picture"
                boxSize="150px"
                labelProps={{
                  fontWeight: "800",
                }}
                imageUrl={
                  instructor &&
                    instructor.InstructorPic
                    ? instructor.InstructorPic
                    : ""
                }
                maxSize={5}
                maxWidth={200}
                maxHeight={150}
                parentCallback={(img_file) => {
                  setInstructor({
                    ...instructor,
                    file: img_file
                  })
                }}
              />
            </>
          }
        />
        <ModalBox
          title="Delete Instructor"
          isOpen={deleteModalIsOpen}
          onClose={() => {
            deleteModalOnClose();
          }}
          isFooter={true}
          onCancel={() => {
            deleteModalOnClose();
          }}
          confirmButtonType={false}
          onConfirm={deleteResource}
          isDeleteButton={true}
          confirmButtonText="Delete"
          description={`Are you sure you want to delete ${instructor?.InstructorName}?`}
        />
      </Box>
    </>
  );
};
